import React from 'react';

import {
  Avatar as ChakraAvatar,
  AvatarBadge,
  AvatarGroup,
  AvatarProps as ChakraAvatarProps,
  useMultiStyleConfig,
} from '@chakra-ui/react';

import { AvatarAdminBadge } from './admin-badge';
import { OrganizationIcon } from './organization';
import { PersonIcon } from './person';

export { AvatarBadge, AvatarGroup };

export type AvatarProps = ChakraAvatarProps & {
  variant?: 'person' | 'organization';
  isAdmin?: boolean;
};

export const Avatar = ({ variant, isAdmin, size, ...props }: AvatarProps) => {
  const styles = useMultiStyleConfig('Avatar', props);
  const CustomIcon =
    variant == 'organization'
      ? OrganizationIcon
      : variant == 'person'
      ? PersonIcon
      : null;

  const icon = props.icon ? (
    props.icon
  ) : CustomIcon ? (
    <CustomIcon
      width="auto"
      height="auto"
      __css={{
        borderRadius: styles.container.borderRadius,
        overflow: 'hidden',
      }}
    />
  ) : undefined;

  return (
    <ChakraAvatar {...props} icon={icon} size={size} variant={variant}>
      {isAdmin ? <AvatarAdminBadge size={size} /> : props.children}
    </ChakraAvatar>
  );
};
